import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BlockScheduleModel } from '../../models/blockschedule.model';

@Component({
  selector: 'app-changeshipdate',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputNumberModule,
    DatePickerModule
  ],
  templateUrl: './changeshipdate.html',
  styleUrl: './changeshipdate.css'
})
export class ChangeshipdateComponent implements OnInit {
  changeShipDateForm: FormGroup;
  selectedCount: number = 0;
  transitDays: number = 0;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.changeShipDateForm = this.createForm();
  }

  ngOnInit(): void {
    // Get selected rows and transit days from dialog data
    if (this.config.data) {
      this.selectedCount = this.config.data.selectedRows?.length || 0;
      this.transitDays = this.config.data.transitDays || 0;

      // Set transit days in form
      this.changeShipDateForm.patchValue({
        transitDays: this.transitDays
      });
    }
  }

  createForm(): FormGroup {
    return this.fb.group({
      transitDays: [{ value: 0, disabled: true }],
      newShipDate: [null, Validators.required],
      newArrivalDate: [{ value: null, disabled: true }]
    });
  }

  onShipDateChange(): void {
    const newShipDate = this.changeShipDateForm.get('newShipDate')?.value;

    if (newShipDate && this.transitDays > 0) {
      // Calculate arrival date = ship date + transit days
      const arrivalDate = new Date(newShipDate);
      arrivalDate.setDate(arrivalDate.getDate() + this.transitDays);

      this.changeShipDateForm.patchValue({
        newArrivalDate: arrivalDate
      });
    }
  }

  onApply(): void {
    if (this.changeShipDateForm.valid) {
      const result = {
        newShipDate: this.changeShipDateForm.get('newShipDate')?.value,
        newArrivalDate: this.changeShipDateForm.get('newArrivalDate')?.value
      };

      this.ref.close(result);
    }
  }

  onClose(): void {
    this.ref.close(null);
  }
}
